export default __webpack_public_path__ + "static/media/persona-run.de29d60e.svg";